import { render, staticRenderFns } from "./RelatorioContestacaoAulaRealizada.vue?vue&type=template&id=e3ec65dc&scoped=true"
import script from "./RelatorioContestacaoAulaRealizada.vue?vue&type=script&lang=js"
export * from "./RelatorioContestacaoAulaRealizada.vue?vue&type=script&lang=js"
import style0 from "./RelatorioContestacaoAulaRealizada.vue?vue&type=style&index=0&id=e3ec65dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ec65dc",
  null
  
)

export default component.exports